import { Component, computed, effect, ElementRef, EventEmitter, HostListener, HostBinding, Output, Renderer2, TemplateRef, untracked, viewChild, Signal, input, signal, inject, output, InputSignal, OnInit, WritableSignal, OutputEmitterRef } from '@angular/core';
import { CdkVirtualScrollViewport, FixedSizeVirtualScrollStrategy } from '@angular/cdk/scrolling';
import { Subscription } from 'rxjs';

import { ActivatedRouteService } from '../../services/route-service/activated-route.service';
import { ClaimPage } from '../../models/claim-page';
import { ILevelGeneralListData, levelGeneralListData } from '../../models/level-general-list-data';
import { ILevelGeneralListDto } from '../../models/level-general-list-dto';
import { LoadingPageService } from '../../services/loading-services/loading-page.service';
import { LoadingTabService } from '../../services/loading-services/loading-tab.service';
import { LogService } from '../../services/log.service';
import { PagerService } from 'src/app/features/shared/pager/pager.service';
import { TabDataService } from 'src/app/features/shared/central-page/services/tab-data.service';
import { TabListService } from 'src/app/features/shared/central-page/services/tab-list.service';
import { ApplicationUserService } from '../../services/application-user.services/application-user.service';
import { _ListService } from '../../services/list-services/_list.service';
import { _PageService } from '../../services/page-services/_page.service';
import { claimName } from 'src/assets/common/enums/claim-name.g';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';
import { ProgressBarService } from 'src/app/features/shared/progress-bar/progress-bar.service';
import { filterSearch, ISortField } from 'src/app/infrastructure/pipes/filter.pipe';
import { IRouteKeyData } from 'src/app/infrastructure/services/route-service/models/route-key-data';

@Component({
    selector: 'app-source-list-base-tool-component',
    template: '',
    styles: [],
})
export abstract class _SourceList_Base_ToolComponent
{
    private __filterStringSubscr?: Subscription;
    private __filterShowSubscr?: Subscription;

    protected readonly abstract _activatedRouteService: ActivatedRouteService;
    protected readonly abstract _listService: _ListService<ILevelGeneralListDto, ILevelGeneralListData>;
    protected readonly abstract _loadingPageService: LoadingPageService;
    protected readonly abstract _loadingTabService: LoadingTabService;
    protected readonly abstract _pageService: _PageService;
    protected readonly abstract _pagerService: PagerService;
    protected readonly abstract _progressBarService: ProgressBarService;
    protected readonly abstract _tabDataService: TabDataService;
    protected readonly abstract _tabListService: TabListService;

    // abstract itemLines$$: WritableSignal<number> | Signal<number>;
    // abstract itemSize$$: WritableSignal<number> | Signal<number>;
    abstract activeGuid$$: WritableSignal<string | null> | Signal<string | null>;
    abstract canClickThrough$$: Signal<boolean>;
    abstract claimPageList$$: WritableSignal<ClaimPage | null> | Signal<ClaimPage | null>;
    abstract filterString$$: WritableSignal<string | null> | Signal<string | null>;
    abstract list$$: WritableSignal<ILevelGeneralListData[] | null> | Signal<ILevelGeneralListData[] | null>;
    abstract listActive$$: WritableSignal<ILevelGeneralListData[]> | Signal<ILevelGeneralListData[]>;
    abstract listAll$$: WritableSignal<ILevelGeneralListData[]> | Signal<ILevelGeneralListData[]>;
    abstract listDeleted$$: WritableSignal<ILevelGeneralListData[]> | Signal<ILevelGeneralListData[]>;
    abstract listDeletedAll$$: WritableSignal<ILevelGeneralListData[]> | Signal<ILevelGeneralListData[]>;
    abstract listFiltered$$: Signal<ILevelGeneralListData[]>;
    abstract listInactive$$: WritableSignal<ILevelGeneralListData[]> | Signal<ILevelGeneralListData[]>;
    abstract loadingPage$$: WritableSignal<boolean> | Signal<boolean>;
    abstract loadingTab$$: WritableSignal<boolean> | Signal<boolean>;
    abstract showSpinner$$: WritableSignal<boolean> | Signal<boolean>;
    abstract matList$$: WritableSignal<ElementRef<any> | null>;
    abstract pageNumber$$: WritableSignal<number | null> | Signal<number | null>;
    abstract pageSize$$: WritableSignal<number | null> | Signal<number | null>;
    abstract scrollElement$$: Signal<HTMLElement | null>;
    abstract scrollPos$$: Signal<number | null>;
    abstract searchFields$$: Signal<string[] | null> | Signal<string[] | null>;
    abstract sortFields$$: Signal<ISortField[]>;
    abstract template$$: Signal<TemplateRef<any> | null>;
    abstract template_buttons$$: Signal<TemplateRef<any> | undefined>;
    abstract template_footer$$: Signal<TemplateRef<any> | undefined>;
    
    protected abstract _list$$: Signal<ILevelGeneralListData[] | null>;

    abstract input_claimPageList$$: InputSignal<ClaimPage | null>;
    abstract input_pageNumber$$: InputSignal<number>;
    abstract input_pageSize$$: InputSignal<number>;
    abstract input_template$$: InputSignal<TemplateRef<any> | null>;

    abstract out_onClick: OutputEmitterRef<ILevelGeneralListData>;

    abstract emit_onFilterChange(): void;
    abstract emit_onScrollEnd(): void;
    abstract activeItem_set(item: ILevelGeneralListData): void;
    abstract trackById(index: number, item: { guid: string }): string;
    abstract ngAfterViewInit(): void;
    abstract ngOnDestroy(): void;
    abstract ngOnInit(): void

    protected abstract _onScrollEnd(): void;
    protected abstract _position_scrollTo(scrollPosition?: number | null): void;

    protected readonly _applicationUserService = injectRequired(ApplicationUserService);

    protected _input_claimPageList$$ = input<ClaimPage | null>(null, {alias: 'claimPageList'});
    protected _input_pageNumber$$ = input<number>(0, {alias: 'pageNumber'});
    protected _input_pageSize$$ = input<number>(0, {alias: 'pageSize'});
    protected _input_template$$ = input<TemplateRef<any> | null>(null, {alias: 'template'});

    protected _out_onClick = output<ILevelGeneralListData>({alias: 'onClick'});

    protected _view_matList$$ = viewChild('matList', { read: ElementRef });
    protected _view_scrollElement$$ = viewChild(CdkVirtualScrollViewport, { read: ElementRef }) ;
    protected _view_template_buttons$$ = viewChild<TemplateRef<any>>('template_buttons');
    protected _view_template_footer$$ = viewChild<TemplateRef<any>>('template_footer');
    
    protected _activeGuid$$ = computed<string | null>(() => this._tabDataService.tabData$$?.()?.activeGuid ?? null);
    // BtnPageDetails_Show — zie _emit_item_click hieronder voor de volledige toelichting. Ook als
    // template-bindbare signal beschikbaar (via canClickThrough$$ override in concrete
    // tool-componenten), zodat rijen zonder deze claim er ook niet meer klikbaar uit hoeven te zien
    // (cursor/hover), i.p.v. alleen functioneel niets te doen.
    protected _canClickThrough$$ = computed<boolean>(() => {
        const __claimPageList = this.claimPageList$$();
        if (!__claimPageList) return true;
        return this._applicationUserService.claim_check(
            __claimPageList, this._routeKeysClaim_get(), claimName.btnPageDetails_Show,
            this._applicationUserService.userClaims$$(),
        );
    });
    protected _claimPageList$$ = signal<ClaimPage | null>(null);
    protected _filterString$$ = computed(() => this._pagerService.filterString$$());
    protected _listActive$$ = computed(() => this._listService.listActive$$());
    protected _listAll$$ = computed(() => this._listService.listAll$$());
    protected _listDeleted$$ = computed(() => this._listDeletedAll$$()?.filter(item => item[levelGeneralListData.deleted] === true && item[levelGeneralListData.inactive] === true));
    protected _listDeletedAll$$ = computed(() => this._listService.listDeletedAll$$());
    // De lijst zoals hij getoond wordt (zoeken + sorteren) — wat voorheen alleen in de template via de
    // filterSearch-pipe bestond. Via de publieke sortFields$$, zodat een eigen sortering van de concrete
    // klasse (bv. checklist edit-modus: aangevinkt bovenaan) blijft gelden.
    protected _listFiltered$$ = computed<ILevelGeneralListData[]>(() => filterSearch(this.list$$(), {
        fields: this.searchFields$$(),
        filter: this.filterString$$(),
        mode: this._pagerService.filterMode$$(),
        sortFields: this.sortFields$$(),
    }));
    // Uit _listDeletedAll$$ (alle niet-actieve rijen), niet uit _listDeleted$$: die bevat al alleen
    // deleted === true, waardoor deze lijst altijd leeg was — de "inactive"-knop en -modus van o.a. de
    // expansion-list (FunctionMembers-historie) verschenen daardoor nooit.
    protected _listInactive$$ = computed(() => this._listDeletedAll$$()?.filter(item => item[levelGeneralListData.deleted] === false && item[levelGeneralListData.inactive] === true));
    protected _loadingPage$$ = computed(() => this._loadingPageService.isLoading$$());
    // Deze specifieke tab (zie loadingTabService.add()/remove() in _source-list-base-feature-
    // component.ts) i.p.v. de pagina-brede loadingPage$$ — die blijft na de initiële page-load
    // permanent false, ook als je later voor het eerst naar een andere tab wisselt.
    protected _loadingTab$$ = computed(() => this._loadingTabService.isLoading$$());
    // Of het laden van de tab-lijst (loadingTab$$) de spinner toont. Overridebaar: een checklist
    // heeft zijn kandidatenlijst alleen in edit-modus nodig, dus terug naar view-modus tijdens het
    // laden moet de (al aanwezige) selectie meteen tonen i.p.v. op de lopende GET te wachten.
    protected _spinnerOnLoadingTab$$: Signal<boolean> = computed(() => true);
    // Vertraagd zichtbaar (zelfde idee als ProgressBarComponent's _delay, zie daar): pas na
    // __spinnerDelayMs tonen, en direct weer verbergen. Voorkomt een korte flits bij bv. een
    // refresh waarbij loadingPage$$ al false wordt terwijl deze tab zijn eigen lijst nog heel
    // kort aan het laden is — zonder vertraging zou de spinner daar zichtbaar oplichten en
    // meteen weer verdwijnen, vóórdat de gebruiker 'm bewust kan waarnemen als "laden".
    private readonly __spinnerDelayMs = 200;
    private __spinnerTimer: ReturnType<typeof setTimeout> | null = null;
    private readonly __showSpinner$$ = signal(false);
    protected _showSpinner$$ = this.__showSpinner$$.asReadonly();
    // Heeft de lijst al rijen? Dan blijft hij tijdens laden staan, gedimd met de spinner eroverheen
    // (list.scss .list-tool--loading / .loading-overlay--over), i.p.v. door de spinner vervangen te
    // worden. loadingTab$$ is één globale teller: ook een ándere lijst die laadt (bv. de checklist die
    // app-mode-swap onzichtbaar voorbereidt) zet de spinner aan — zonder dimmen werd de tab dan leeg.
    protected _hasRows$$ = computed(() => (this._list$$()?.length ?? 0) > 0);
    @HostBinding('class.list-tool--loading') get classLoading(): boolean { return this.__showSpinner$$() && this._hasRows$$(); }
    protected _matList$$ = signal<ElementRef<any> | null>(null);
    protected _pageNumber$$ = signal<number | null>(null);
    protected _pageSize$$ = signal<number | null>(null);
    // Het element dat scrollt: de virtual-scroll-viewport, anders de lijst zelf (checklist: #matList
    // scrollt, zie list.scss). Lijsten met een eigen scroll-container overschrijven dit.
    protected _scrollElement$$ = computed<HTMLElement | null>(() =>
        (this._view_scrollElement$$() ?? this._view_matList$$())?.nativeElement ?? null);
    protected _scrollPos$$ = computed(() => this._tabDataService.scrollPos$$() ?? null);
    protected _template_buttons$$ = signal<TemplateRef<any> | null>(null);
    protected _template_footer$$ = signal<TemplateRef<any> | null>(null);
    protected _searchFields$$ = computed(() => this._tabDataService.searchFieldsActive$$());
    protected _sortFields$$ = computed(() => this._tabDataService.sortFields$$());

    @Output() loadedEmit = new EventEmitter();

    @HostBinding('class') class = 'list-tool';
    @HostListener('document:click', ['$event'])
        clickOutside(event: MouseEvent) {
            if (!this._view_matList$$()?.nativeElement.contains(event.target)) {
                this._activeItem_set(null);
            }
        }
    
    // protected _isRestoringScroll = false;
    private __scrollRestored = false;

    constructor(
        protected _renderer?: Renderer2
    ) {
        effect(() => {
            const __list = this._list$$();
            const __tabName = this._tabDataService.TabName;
            const __scrollPos = this._tabDataService.ScrollPos; // 👈 FIX

            if ((__list?.length ?? 0) > 0 && __scrollPos != null) {
                if (!this.__scrollRestored) {
                    this.__scrollRestored = true;
                    this._position_scrollTo();
                }

                LogService.envDev.logObject(`load [${__tabName ?? 'unknown'}]`, __list);
                this.loadedEmit.emit();
            }
        });

        effect(() => {
            const __loading = this._loadingPage$$() || (this._loadingTab$$() && this._spinnerOnLoadingTab$$());

            if (__loading) {
                this.__spinnerTimer ??= setTimeout(() => {
                    this.__spinnerTimer = null;
                    this.__showSpinner$$.set(true);
                }, this.__spinnerDelayMs);
            } else {
                if (this.__spinnerTimer) {
                    clearTimeout(this.__spinnerTimer);
                    this.__spinnerTimer = null;
                }
                this.__showSpinner$$.set(false);
            }
        });

        // Zichtbare spinner = de footer-progressbar is dubbelop, dus onderdrukken. Tijdens de
        // page-load niet: dan is de pagina-inhoud (en deze spinner) verborgen en is de balk juist
        // de enige feedback. Afmelden in _ngOnDestroy.
        effect(() => {
            const __visible = this.__showSpinner$$() && !this._loadingPage$$();
            untracked(() => this._progressBarService.spinner_set(this, __visible));
        });
    }

    protected _ngOnInit(): void {
        // const __tabIndex = this._tabListService.TabIndex;
        // const __tabList = this._tabListService.TabList;
        // this._tabDataService.TabData = __tabList[__tabIndex];

        this._claimPageList$$.set(this._input_claimPageList$$());
        this._matList$$.set(this._view_matList$$() ?? null);
        this._pageNumber$$.set(this._input_pageNumber$$());
        this._pageSize$$.set(this._input_pageSize$$());
        this._template_buttons$$.set(this._view_template_buttons$$() ?? null);
        this._template_footer$$.set(this._view_template_footer$$() ?? null);
    }

    protected _emit_onFilterChange(): void {
        this._tabDataService.ScrollPos = 0;
        this._position_scrollTo(0);
    }

    // BtnPageDetails_Show bepaalt of een rij een klikbare link naar de detailpagina heeft — apart van
    // Page_Read (toont de lijst zelf). Backend bundelt deze claim al standaard mee (singular _Read-
    // Activity naast de plural _Read), maar tot nu toe las geen enkele tablist 'm ooit uit — hier
    // centraal afgedwongen zodat het voor alle tablist/checklist-componenten in één keer klopt.
    protected _emit_item_click(event: MouseEvent, item: ILevelGeneralListData): void {
        event.stopPropagation(); // prevent outside click
        if (!this._canClickThrough$$()) return;

        this._activeItem_set(item);
        this._out_onClick.emit(item);
    }

    protected _activeItem_set(item?: ILevelGeneralListData | null): void {
        this._tabDataService.ActiveGuid = item ?? null;
    }

    // RouteKeys voor de knop-/klik-claims van deze lijst. Een pagina zonder domain-scope (Home, zie
    // _TabPageService.tabAuth_noDomainScope) checkt op de null-scope claims: routeKeys valt anders
    // terug op de nog geladen domainUserData (bv. direct na inloggen het laatst gebruikte domain),
    // waardoor dGuid niet matcht en bv. BtnPageDetails_Show ten onrechte faalt.
    protected _routeKeysClaim_get(): IRouteKeyData | null {
        return this._tabListService.tabAuth_noDomainScope ? null : this._activatedRouteService.routeKeys;
    }

    protected _trackById(item: { guid: string }): string {
        return item.guid;
    }

    protected _ngAfterViewInit(): void {
        setTimeout(() => {
            const _tabName = this._tabDataService.tabName$$();
            if (!_tabName) return;

            this._tabListService.tabList_addFooter(untracked(() => _tabName), this.template_footer$$() ?? null);
            this._tabListService.tabList_addContentButtons(untracked(() => _tabName), this.template_buttons$$() ?? null);
        }, 0);
    }

    protected _ngOnDestroy(): void {
        this.__filterShowSubscr?.unsubscribe();
        this.__filterStringSubscr?.unsubscribe();
        this.loadedEmit?.unsubscribe();
        if (this.__spinnerTimer) clearTimeout(this.__spinnerTimer);
        this._progressBarService.spinner_set(this, false);
    }
}
